/* eslint-disable */
import React, { Component } from 'react'
import { ListView, Keyboard, Alert, SafeAreaView, View, ScrollView, Text, TextInput, KeyboardAvoidingView, Dimensions, FlatList, TouchableOpacity } from 'react-native'

import { connect } from 'react-redux'

import BaseScreen from './BaseScreen'
import MainNavBarScreen from './MainNavBarScreen'
import AuthActions from '../Redux/AuthRedux';
import UserActions from '../Redux/UserRedux'
import PostsActions from '../Redux/PostsRedux'

import styles from './Styles/PostCommentsScreenStyle'
import PostViewComponent from '../Components/PostViewComponent'
import I18n from "i18n-js"

// pass in navigation param isPopup to display abbreviated comment entry component, no list, no full screen

class PostViewScreen extends Component {

  constructor(props) {

    super(props)
    console.tron.display({name: 'PostViewScreen', preview: "constructor", value: {props: props}})

    // from navigation
    this.actualNavParams = (this.props.navigation && this.props.navigation.state) ? this.props.navigation.state.params : null

    // if we passed in params as a prop, use it instead
    this.params = this.props.altNavParams ? this.props.altNavParams : this.actualNavParams

    console.info("PostViewScreen this.params = " + JSON.stringify(this.params))

    this.state = {
      following: [],
      haveReloadedPost: false,
      postId: this.params.post.postId, 
      post: this.params.post,
      isPopup: this.params.isPopup,
      loading: false
    }

    this.goBackPress = this.goBackPress.bind(this)
    this.updateInterval = setInterval(() => {
      if (this.postViewComponentRef) {
        this.postViewComponentRef.refreshComments()
      }
    }, 3000)
  }

  componentDidMount() {
    
    // only put the back button on if we got here thru normal navigation
    // if we pass in altNavParams prop, it means we go here not via the stack navigator
    if (!this.props.altNavParams)
      this.navigationBar.setLeftNavBarButtons([ { onPress: this.goBackPress, type: 'back' } ])

    if (this.state.post) this.props.readPost({ PostId: this.state.post.PostId })
    this.props.listFollowing(this.props.auth.user.UserId, 0)
  }

  componentWillUnmount() {
    if (this.updateInterval) clearInterval(this.updateInterval)
  }

  componentDidUpdate(prevProps, prevState) {

    let prevParams = this.params

    this.params = this.props.altNavParams ? this.props.altNavParams : this.actualNavParams

    let postId = 0

    if (this.params && this.params.post) {
      console.log('PostViewSCREEN componentDidUpdate postId is now ' + this.params.post.postId + " or " + this.params.post.PostId)
      postId = this.params.post.postId ? this.params.post.postId : this.params.post.PostId
    }
    else 
      console.log('PostViewSCREEN componentDidUpdate but no postId!')

     
    // have to check if postId changed, or we get into a component did update recursive loop
    if (this.state.postId != postId) {
        console.info("*** updating postId in post view screen to " + postId)
        this.setState({
        postId: postId, // this.params.post.postId, 
        post: this.params.post
        })

        // this is done in did mount so re-do it if postId changes but dont bother to wait for setState to finish
        
        if (this.state.post) this.props.readPost({ PostId: postId })
        this.props.listFollowing(this.props.auth.user.UserId, 0)
    
    }
    if (!this.state.haveReloadedPost && prevProps.post != this.props.post && this.props.post && this.props.post.PostId == this.state.postId) {
      console.tron.log(`PostView componentDidUpdate, have read in latest Post record`)
      this.setState({
        haveReloadedPost: true,
        post: this.props.post,
      })
    }
    else {
      // check if comments did update by looking at recent comments
      console.log("PostViewSCREEN this.props.post = " + JSON.stringify(this.props.post, null, 2))
      //if (JSON.stringify(prevProps.post.RecentComments) != JSON.stringify(this.props.post.RecentComments)) {
        console.log("PostViewSCREEN recent comments may have changed")
        if (this.postViewComponentRef) {
          this.postViewComponentRef.refreshComments()
        }
      //}
    }
  }

  goBackPress() {
    //const { params } = this.props.navigation.state
    this.params._onRefresh()
    this.props.navigation.goBack()
  }

  render() {
    console.tron.display({name: 'PostViewScreen', preview: "render", value: {props: this.props, state: this.state}})
    //const { params } = this.props.navigation.state
    const params = this.params // to avoid changing code
    // if we change the key when post changes then it will do a full component constroctor on PostViewComponent
    // https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state
    // the above example just uses time stamp to change key but that is too much
    // so we check postid change e.g. set key to current postId
 
    if (true || !this.state.isPopup)
      return (
        <BaseScreen darkStatusbar loading={this.props.fetching || this.state.loading} style={{width: '100%', borderLeftWidth:1, borderColor: 'rgba(0,0,0,0.2)'}} >
          <MainNavBarScreen ref={(view) => { if (view) this.navigationBar = view }} title={I18n.t('postDetail.title')} />
          {this.state.post && <PostViewComponent 
            key={"pvc" + this.state.post.PostId}
            standaloneScreen={this.props.standaloneScreen}
            isPopup={this.state.isPopup}
            ref={(r) => this.postViewComponentRef = r}
            parent={this} 
            Post={this.state.post} 
            defaultTab={params.defaultTab} 
            onRefresh={params._onRefresh}
            onLoading={(x) => this.setState({loading : x})}
            commentTimeStamp={params.commentTimeStamp} 
            navigation={this.props.navigation} 
            auth={this.props.auth} 
            close={( ) => null }
            following={this.props.following}
            loveChanges={this.props.loveChanges}
          />}
          {!this.state.post && <Text>no post object to display PostViewComponent</Text>}
        </BaseScreen>
        )
      else return (
        <PostViewComponent 
            isPopup={this.state.isPopup}
            ref={(r) => this.postViewComponentRef = r}
            parent={this} 
            Post={this.state.post} 
            defaultTab={params.defaultTab} 
            onRefresh={params._onRefresh}
            commentTimeStamp={params.commentTimeStamp} 
            navigation={this.props.navigation} 
            auth={this.props.auth} 
            close={( ) => null }
            following={this.props.following}
            loveChanges={this.props.loveChanges}
          />
      )

      
    
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    following: state.user.following, // state.getFollow.data
    loveChanges: state.love.changes,
    post: state.posts.readPost,
  }
}

const mapDispatchToProps = dispatch => ({
  listFollowing: (UserId, next) => dispatch(UserActions.listFollowingRequest({ UserId: UserId, next: next })),
  readPost: (post) => dispatch(PostsActions.readPostRequest(post)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PostViewScreen)
